<template>
    <v-card class="pa-5">
        <v-icon class="modal-close" @click.native="CLOSE_MODAL()">close</v-icon>
        <v-card-title class="display-1 mb-4">{{$t("Удаление записи из избранного")}}</v-card-title>
        <v-card-text class="title mt-4">{{$t("Усовершенствован раздел «База знаний» на портале. Теперь можно скачивать материалы прямо на рабочий компьютер, телефон или планшет.")}}</v-card-text>
        <v-card-actions>
            <v-layout align-center wrap justify-space-between mt-4>
                <buttonRed :class="{'flex xs12': $vuetify.breakpoint.xs, 'sm6 pr-4': $vuetify.breakpoint.smAndUp}">{{$t("Удалить")}}</buttonRed>
                <buttonBdWhite :class="{'flex xs12 mt-3': $vuetify.breakpoint.xs, 'sm6': $vuetify.breakpoint.smAndUp}" @click.native="CLOSE_MODAL()">{{$t("Отмена")}}</buttonBdWhite>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
import buttonRed   from '@/components/ui/buttons/button_red';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    buttonRed,
    buttonBdWhite,
  },
  methods: {
    ...mapMutations('favourites', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
  },

};
</script>

<style>

</style>
